export const strainNames = [
  {
    "name": "$100 OG",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "'98 Aloha White Widow",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "1024",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "10th Planet",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "12 Year OG",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "13 Dawgs",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "2 Fast 2 Vast",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "22",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "24k Gold",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "3 Bears OG",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "3 Kings",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "303 OG",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "3D CBD",
    "category": "Sativa",
    "topEffect": "Happy"
  },
  {
    "name": "3X Crazy",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "3rd Coast Panama Chunk",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "501st OG",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "541 Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "5k Puff",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "5th Element",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "60 Day Lemon",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "60 Day Wonder",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "707 Headband",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "707 Truthband",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "8 Ball Kush",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "818 OG",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "831 OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "840",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "9 Pound Hammer",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "91 Krypt",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "92 OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "999",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "9D4",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "A La Mode",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "A-10",
    "category": "Indica",
    "topEffect": "Creative"
  },
  {
    "name": "A-Dub",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "A-Train",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "ACDC",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "AK Choco Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "AK-020",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "AK-47",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "AK-48",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "AK-49",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "AK-OG Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Aberdeen",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Above and Beyond",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Absinthe",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Abusive OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Acai Berry Gelato",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Acapulco Gold",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Ace Killer OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Ace of Spades",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Aceh",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Acid",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Acid Dough",
    "category": "Sativa",
    "topEffect": "Happy"
  },
  {
    "name": "Afcrack",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Afghan Big Bud",
    "category": "Indica",
    "topEffect": "Happy"
  },
  {
    "name": "Afghan Cow",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Afghan Diesel",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Afghan Hawaiian",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Afghan Haze",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Afghan Kush",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Afghan Skunk",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Afghan Sour Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Afghan Widow",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Afghani",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Afghani Bullrider",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Afghani CBD",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Afghani Krush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Afghanica",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Afghanimal",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Afghooey",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Afgoo",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Afgooey",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Afkansastan",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Afpak",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "African",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Afrikaner",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Afrodite",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Afternoon Delight",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Afwreck",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Agape",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Agent Orange",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Agent Tangie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Agharta",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Air Jordan OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Al's Dream",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Alaska",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Alaska Thunder Grape",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Alaskan Ice",
    "category": "Sativa",
    "topEffect": "Euphoric"
  },
  {
    "name": "Alaskan Thunder Fuck",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Albert Walker",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Alchemy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Alf",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Alice",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Alice in Wonderland",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Alien Abduction",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Alien Apparition",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Alien Asshat",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Alien Breath",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Alien Bubba",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Alien Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Alien Dawg",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Alien Dutchess",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Alien Hallucination",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Alien Inferno",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Alien Kush",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Alien OG",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Alien Reunion",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Alien Rift",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Alien Rock Candy",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Alien Sour Apple",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Alien Stardawg",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Alien Technology",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Alien Walker",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Aliens On Moonshine",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Alion",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Allen Iverson OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Allen Wrench",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Alley Cat Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Allkush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Aloha",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Aloha Grape Stomper",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Aloha Limone",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Alohaberry",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Alpha Blue",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Alpha Cow",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Alpha Express",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Alpha OG",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Alphadawg",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Alpine Blue",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Alpine Star",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Altoyd",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ambrosia",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "American Beauty",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "American Dream",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "American Kush",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "American Pie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Americano",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Amethyst",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Amethyst Bud",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Amherst Sour Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Amnesi-K Lemon",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Amnesia",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Amnesia Flash",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Amnesia Ganja Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Amnesia Haze",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Amnesia OG",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Amnesia White",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Ancient Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Ancient OG",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Anesia Scout Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Anesthesia",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Angel OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Angelica",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Animal Blues",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Animal Cookies",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Animal Gas",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Animal Land",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Animal Mints",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Animal Sherbert",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Anonymous OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Anubis",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Ape Shit",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Apollo 11",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Apollo 13",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Apollo 13 Haze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Apollo Haze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Appalachia",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Appalachian Power",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Apple Fritter",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Apple Jack",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Apple Kush",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Appleberry",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Apricot Jelly",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Arabian Gold",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Arctic Sun",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "ArcticBlue",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Area 51",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Argvana Heat",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Argyle",
    "category": "Indica",
    "topEffect": "Happy"
  },
  {
    "name": "Arjan's Strawberry Haze",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Arjan's Ultra Haze #1",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Armageddon",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Armagnac",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ash",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Asian Fantasy",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Aspen OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Aspirare",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Astral Works",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Astroboy",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Athabasca",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Atmosphere",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Atomic",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Atomic Bomb",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Atomic Goat",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Atomic Northern Lights",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Atomical Haze",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Aurora Borealis",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Aurora Indica",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Avalon",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Avi",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Avi-Dekel",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Ayahuasca Purple",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Aymi",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Azure Haze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "B-52",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "B-Witched",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "B.B. King",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "B4",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "BC Big Bud",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "BC Roadkill",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "BC Sweet Tooth",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "BHŪ",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "BOG Bubble",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "BSC",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Bacio Gelato",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bad Azz Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Badazz Cheese",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Bakers Delight",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bakerstreet",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Balmoral",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Banana Bread",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Banana Candy",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Banana Cream OG",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Banana Daddy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Banana Diesel",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Banana Fruit Bound",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Banana Hammock R1",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Banana Kush",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Banana Mango",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Banana Milk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Banana OG",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Banana Peel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Banana Puff",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Banana Punch #9",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Banana Sorbet",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Banana Split",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Bananas",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Bandana",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bandersnatch",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bangi Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Bango",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Banjo",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Barbara Bud",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Batgirl",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Batman OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Bay 11",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Bay Dream",
    "category": "Sativa",
    "topEffect": "Hungry"
  },
  {
    "name": "Bay Lotus",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bay Platinum Cookies",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Bazooka Joe G",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bear Creek Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bear Dance",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Beastmode 2.0",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Beastmode OG",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Beckwourth Bud",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Bedford Glue",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bedica",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Bediol",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Bell Ringer",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Belladonna",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Bergamot",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Berkeley",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Bermuda Sour",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Berries & Crème",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Berry Blossom",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Berry Bomb",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Berry Larry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Berry Noir",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Berry OG",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Berry White",
    "category": "Indica",
    "topEffect": "Talkative"
  },
  {
    "name": "Bert's Cookie Dough",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bertberry Cheesecake",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Best Friend OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bettie Page",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Bianca",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bianca Fire",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Biddy Early",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Big Band",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Big Bang",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Big Bazooka",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Big Bomb",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Big Bud",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Big Buddha Cheese",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Big Buddha’s King Kong",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Big Bull",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Big Holy Nina",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Big Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Big Mac",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Big Skunk Korean",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Big Sky OG",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Big Smooth",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Big Sur Holy Bud",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Big Tooth",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Big White",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Big Wreck",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Biker Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Biker Le’Blanc",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bingo Pajamas",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bio-Diesel",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Bio-Jesus",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Biochem",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Biohazard",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Birds Eye",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Birds of Paradise",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Birthday Cake Kush",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Black '84",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Black Afghan",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Black Betty",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Black Bubba",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Black Cheese",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Black Cherry Cheesecake",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Black Cherry OG",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Black Cherry Pie",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Black Cherry Soda",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Black Cream Auto",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Black D.O.G.",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Black Dahlia",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Black Diamond",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Black Diesel",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Black Domina",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Black Fire",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Black Haze",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Black Ice",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Black Jack",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Black Label",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Black Label Kush",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Black Lime Special Reserve",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Black Lotus",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Black Magic",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Black Magic Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Black Mamba",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Black Out",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Black Raspberry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Black Rose",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Black Roses",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Black Russian",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Black Triangle",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Black Tuna",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Black Velvet",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Black Widow",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Blackberry",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Blackberry Bubble",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Blackberry Chem OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blackberry Cobbler",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blackberry Cream",
    "category": "Indica",
    "topEffect": "Happy"
  },
  {
    "name": "Blackberry Diesel",
    "category": "Sativa",
    "topEffect": "Happy"
  },
  {
    "name": "Blackberry Dream",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Blackberry Fire",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blackberry Hashplant",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Blackberry Haze",
    "category": "Sativa",
    "topEffect": "Happy"
  },
  {
    "name": "Blackberry Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Blackberry Lime Haze",
    "category": "Sativa",
    "topEffect": "Happy"
  },
  {
    "name": "Blackberry Moonrocks",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blackberry OG CBD",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blackberry Pie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blackberry Rhino",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Blackberry Snow Cone",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Blackberry Trainwreck",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Blackberry x Blueberry",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Blackwater",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Blanco Berry Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blaze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Blessings OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bleugenius",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blissful Wizard",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Blizzard Bush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blob OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blockhead",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Bloo's Kloos",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Blood Orange Kush",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Blood Orange Sorbet",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bloodhound",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Bloodwalker",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Blowfish",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Blucifer",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Blue Afghani",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Blue Alien",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Blue Bastard",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Blue Bayou",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Blue Blood",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Blue Boy",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Blue Buddha",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Blue Champagne",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Blue Cheese",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Blue Cinex",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Blue Cookies",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Blue Crack",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Blue Diamond",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Blue Diesel",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Blue Dot",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Blue Dragon",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Blue Dream",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Blue Dream CBD",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue Dynamite",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Blue Fire",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue Flame",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue Frost",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Blue Galaxy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue God",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Blue Goo",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Blue Hash",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Blue Hawaiian",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Blue Haze",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Blue Heron",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue Iguana",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue Ivy",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Blue J",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Blue Jay Way",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue Kiss",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue Knight",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Blue Kripple",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Blue Kross",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue Kush",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Blue Lights",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Blue Magic",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Blue Magoo",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Blue Monster",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Blue Moon Rocks",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Blue Moonshine",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Blue Mountain Fire",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Blue Mystic",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Blue Nightmare",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Blue Nina",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue OG",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Blue OG Sherbert",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue Ox",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Blue Persuasion",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue Power",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Blue Raspberry Snow Cone",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue Rhino",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Blue Satellite",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Blue Sherbert",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Blue Sky",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Blue Steel",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Blue Tahoe",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue Tara",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue Thai",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue Trainwreck",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Blue Trane",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue Treat",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue Velvet",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Blue Venom",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Blue Widow",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Blue Wolf",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Blue Wonder",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blue Wreck",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Blue Zkittlez",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Blue Zombie",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Blueberry",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Blueberry AK",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blueberry Blast",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Blueberry Bomb",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blueberry Cheesecake",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Blueberry Cookies",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Blueberry Diesel",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Blueberry Dream",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Blueberry Essence",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Blueberry Hashplant",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blueberry Haze",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Blueberry Headband",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Blueberry Jack",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Blueberry Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Blueberry Lambsbread",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Blueberry Muffin",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Blueberry OG",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Blueberry Pancakes",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Blueberry Pie",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Blueberry Silvertip",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Blueberry Skunk",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Blueberry Space Cake",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Blueberry Triple OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Blueberry Waltz",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Blueberry Yum Yum",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Blues",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Blukashima",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bluniverse",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Blurple",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Blush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bob Saget",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Bodega Bubblegum",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bog Blue Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Bog Sour Grape",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Bogart",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Boggle Gum",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Bogglegum",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bona Dea",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Bonkers",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Booger",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Boombaye",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bootlegger",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bootylicious",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bordello",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Boss Hogg",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Boss OG",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Boysenberry ",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Brain Candy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Brains Damage",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Brainstorm Haze",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Brainwreck",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Brand X",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Brandywine",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Brazil Amazonia",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Breakout",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Brian Berry Black Currant",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Brian Berry Citrus Blend",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Brian Berry Cough",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Brian Berry Honey Lemon",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bright Fire",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Bright Floral Light",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bright Moments",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bright Moments",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bright Puff",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Broke Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bronze Whaler",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Brooklyn Mango",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bruce Banner",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Bruce Banner #3",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Brute Fruit",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bubba 76",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bubba Berry",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Bubba Cheese Auto",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bubba Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bubba Doja",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Bubba Fresh",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bubba Hash",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Bubba Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Bubba Kush 2.0",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bubba OG",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Bubba Tom Hayes",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bubba x Skunk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bubba's Bitch",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Bubba's Gift",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Bubble Bomb",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bubble Cheese",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Bubble Gum",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Bubbleberry",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Bubblegum Kush",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Bubblegun",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Bubblicious",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Buckeye Purple",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Buddha Haze",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Buddha OG Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Buddha Syrup",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Buddha Tahoe",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Buddha Vesta",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Buddha White Dwarf",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Buddha's Hand",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Buddha's Sister",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Buddha’s Tooth",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Budzilla",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Buffalo Bill",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Buford OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Bugatti OG",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Burgundy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Burkle",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Burmese Kush",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Burning Desire",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Burnt Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Butter OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Butterscotch",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Buzz Bomb",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "C13 Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "C3",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "C3PO",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "C4",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "CBD Blue Shark",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "CBD Critical Cure",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "CBD Critical Mass",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "CBD Kush",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "CBD Lilly",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "CBD Mango Haze",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "CBD OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "CBD OX",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "CBD Rich Blessing",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "CBD Shark",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "CHR Super OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "CSG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cabbage Patch",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Caboose",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cackleberry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cactus",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Cactus Cooler",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cadillac Cookies",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Cadillac Purple",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Cakewalk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cali Dragon",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cali Gold",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Cali Jack",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cali Kush",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Cali Orange Bud",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "California Black Roze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "California Gold",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "California Grapefruit",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "California Hash Plant",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "California Limes",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "California Love OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "California Orange",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "California Orange Cheese",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "California Sour",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "California Sour Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Calyx OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cambodian",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Cambodian Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Candy Apple",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Candy Cane",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Candy Drop",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Candy Jack",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Candy Store",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Candyland",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Canna-Tsu",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Canna-Wreck",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "CannaSutra",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Cannadential",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Cannalope Haze",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Cannalope Kush",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Cannatonic",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Capers",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Capleton",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Captain America OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Captain's Cake",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Caramel Cake",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Caramel Candy Kush",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Caramel Kona Coffee Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Caramel Kona Coffee Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Caramelicious",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Caramella",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Caramelo",
    "category": "Sativa",
    "topEffect": "Tingly"
  },
  {
    "name": "Carl Sagan",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Carmel Cough",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Carnival",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Carpet Tape",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cascadia Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Casey Jones",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Cashus Clay",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Casper OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Cat Piss",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Cataract Kush",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Catfish",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Cello Sweet OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Central American",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Cereal Milk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cerebro Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Chairman Chem Sou",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Champagne Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Champagne Kush",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Chardonnay",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Charity OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Charlie Sheen",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Charlotte's Web",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Cheddarhead",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cheddarwurst",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cheddarwurst 2",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cheese",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Cheese Candy",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Cheese Dawg",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cheese Quake",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Cheeseburger",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cheesewreck",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Cheetah Piss",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chef Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Chem Berry Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chem Beyond Diesel CBD",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chem Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chem Crush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chem D.O.G.",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Chem Jack",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chem Jong Ill",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chem Kesey",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chem Scout",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Chem Valley Kush",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Chem's Sister",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "ChemWreck",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Chemdog",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Chemdog #4 x Alien OG Kush",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Chemdog 4",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Chemdog 91",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Chemdog Sour Diesel",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Chemmy Jones",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Chemnesia",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chemo",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "CherWillie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chernobyl",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Cherries Jubilee",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Cherry AK-47",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Cherry Bomb",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Cherry Cookies",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Cherry Cream Pie",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Cherry Dawg",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cherry Diesel",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Cherry Durban Poison",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cherry Fire",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cherry Fuel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cherry Grapefruit",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cherry Kiss",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cherry Kola",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Cherry Kush",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Cherry Limeade",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Cherry Mender",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Cherry Meringue",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cherry Moon Pie",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Cherry OG",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Cherry Pie",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Cherry Pie Kush",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Cherry Puff",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cherry Sauce",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cherry Sherbet",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Cherry Skunk",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Cherry Slyder",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cherry Thunder Fuck",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Cherry Vanilla Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cherry Wine",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Cheshire Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chicago Typewriter",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chicle",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chiesel",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "China Yunnan",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Chiquita Banana",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Chloe",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Chocoholic",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chocolate Cheesecake",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chocolate Chunk",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Chocolate Diesel",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Chocolate Drop",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chocolate Fondue",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Chocolate Glue",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Chocolate Hashberry",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Chocolate Kush",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Chocolate Lava",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chocolate Meringue",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Chocolate Mint OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chocolate OG",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Chocolate Rain",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chocolate Sap",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chocolate Skunk",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Chocolate Thai",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Chocolate Thunder",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Chocolate Tonic",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chocolony",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chocolope",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Chocolope Kush",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Chong Star",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Chronic",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Chronic Thunder",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Chuck OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chucky's Bride",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Chunky Diesel",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Chupacabra",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Church OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Cinderella 99",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Cinderella's Dream",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Cindy Haze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cindy Le Pew",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cindy White",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Cinex",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Circus Peanuts",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cirrus",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Citradelic Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Citradelic Sunset",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Citral Flo",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Citral Flow Bx1",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Citral Glue",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Citral Skunk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Citrix",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Citrus Kush",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Citrus Punch",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Citrus Rush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Citrus Sap",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Citrus Sunshine Haze",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "City of God",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Classic Twist",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Clementine",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Clementine Kush",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Clementine’s Terpentine",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Clockwork Orange",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cloud 9",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "CloudCap",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Club 69",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Cluster Bomb",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cluster Funk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cobbler",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cobra Lips",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cocoa Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Coconut Oil",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cold Creek Kush",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Cole Train",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Colin OG S1",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Collie Man Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Colombian Gold",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Colombian Mojito",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Colorado Bubba",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Colorado Chem",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Colorado Chem RBX3",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Colorado Clementines",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Colorado Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Comfortably Dumb",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Commerce City Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Concord Cream",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Concord Grape Blockhead",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Confidential Cheese",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Confidential Cookies",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Confidential Wreck",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Congo",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Connie Chung",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Conspiracy Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Cookie Breath",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Cookie Dough",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Cookie Jar",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cookie Monster",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Cookie Pebbles F3",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cookie Pebbles OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cookie Puss",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cookie Wreck",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Cookies Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Cookies Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Cookies and Cream",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Cookies and Cream Cheese",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cookies and Dream",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Copacabana",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Copper Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Corleone Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Corleone Kush The Don Cut",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cornbread",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Cornerstone",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cosmic Collision",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Cotton Candy Cane",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cotton Candy Kush",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Cotton Purple Chem",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cougar Milk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cougar Piss",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cowboy Kush",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Coyote Art",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cracker Jack",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Crater Lake",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Crazy Miss Hyde",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Cream Caramel",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Crescendo RBx1",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Crimea Blue",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Critical",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Critical 47",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Critical Bilbo",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Critical Cheese",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Critical Haze",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Critical Hog",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Critical Jack",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Critical Kali Mist",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Critical Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Critical Mass",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Critical Plus",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Critical Plus 2.0",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Critical Purple Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Critical Sensi Star",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Critical Skunk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Critical Soma",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Critical Widow",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Critters Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Crockett’s Confidential",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Crockett’s Dog",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Crockett’s Haze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Crockett’s Sour Tangie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Cronuts",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Crosswalker",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Crouching Tiger Hidden Alien",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Crown OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Crown Royale",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Crumbled Lime",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Crunch Berry Kush",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Crypt",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Crystal Coma",
    "category": "Sativa",
    "topEffect": "Euphoric"
  },
  {
    "name": "Crystal Gayle",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Crystalberry",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Cuvee",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Cypress OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "D Cure",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "DJ Andy Williams",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "DJ Short Blueberry",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "DJ Smoke",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "DJ's Gold",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dagwood",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dairy Queen",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Dakini  Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Damn Sour",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Damnesia",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dance World",
    "category": "Sativa",
    "topEffect": "Happy"
  },
  {
    "name": "Dancehall",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Dank Commander",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dank Dough",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dank Schrader",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Dank Sinatra",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Danky Doodle",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Dark Blue Dream",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Dark Shadow Haze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dark Side of the Moon",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Dark Star",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Darkside OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Darth Vader OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Dawg's Waltz",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Dawgfather OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Day Tripper",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Daybreaker",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Daywalker",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "DeDutch",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Deadhead OG",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Deadlights",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Deadwood",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Death Bubba",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Death By Cake OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Death Star",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Death Star OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Dedoverde Haze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Deep Breath",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Deep Cheese",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Deep Chunk",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Deep Purple",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Deep Sleep",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "DelaHaze",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Denver Maple",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Des*Tar Bx",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Desert Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Desert Star",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Designer OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Destroyer",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Devil",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Devil Fruit",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Devil's Tit",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Diabla",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Diablo",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Diamond OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Diamond Socks",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Diamond Valley Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dick Cheese",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Diesel Dough",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Diesel Drift",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Diesel Duff",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Diesel Glue",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dieseltonic",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Digweed",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Dinachem",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dinamex",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dirt Nap",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dirty Girl",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Dirty Old Bastard",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Dirty Widow",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Disney Blue",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Divina Obscura",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dizzy OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Django",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Do-Over OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Do-Si-Dos",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Doc Holliday",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Doctor Doctor",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Doctor Jamaica",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Doc’s OG",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Dog Face",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dog Shit",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Dogwalker OG",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Dolato",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Dolce Gelato",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dolla Sign OG Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Domino",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Don Carlos",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Don Shula",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Don's Ghost",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Donegal",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Donkey Butter",
    "category": "Indica",
    "topEffect": "Happy"
  },
  {
    "name": "Donna OG",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Doobiebird Daydream",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Doox",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Doox",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dopium",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Dorit",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Dosi Face",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dosi Punch",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Dosi White",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dosi-Cake",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dosi-Woah! R1",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Double Barrel OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Double Diesel",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Double Dream",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Double Dutch",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Double Gum",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Double Lemon Pie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Double Mint",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Double OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Double Purple Doja",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Double Stuffed Sorbet",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Double Tangie Banana",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Double Tap",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Doug's Varin",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Dough Lato",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dr. Bubbles",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dr. Clemenstein",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dr. Feelgood",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dr. Funk",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Dr. Greenthumb’s Em-Dog",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dr. Grinspoon",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Dr. Quantum",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dr. Who",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Dragon Fruit",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dragon OG",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Dragon Punch",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dragon's Breath",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Dreadlock",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dream Beaver",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Dream Berry",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Dream Girl",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dream Lotus",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Dream Machine",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dream Police",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dream Queen",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Dream Star",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Dreamcatcher",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Dreamer’s Glass",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dreamtime",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Drizella",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Duct Tape",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Duke Nukem",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Durban Berry",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Durban Cheese",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Durban Cookies",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Durban Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Durban Poison",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Durban Princess",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Durga Mata",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Durga Mata II",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dutch 47",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dutch Crunch",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dutch Dragon",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Dutch Dynasty",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dutch Hawaiian",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Dutch Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Dutch Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Dutch Queen",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Dutch Thunder Fuck",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Dutch Treat",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Dutch Treat Haze",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Dutchberry",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Dynamite",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Eagle Bill",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Early Girl",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Early Glue RBx1",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Early Lemon Berry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Early Miss",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Early Pearl",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Early Queen",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Early Skunk",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Earth OG",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Earthquake",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Earthshaker OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "East Coast Alien",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "East Coast Sour Diesel",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "East Coast Sour Diesel",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Eastern European",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Easy Bud",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Easy Peezy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ebola #7",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ecto Cooler",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Ed Rosenthal Super Bud",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Edelweiss",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "EdiPure Dried Pineapples",
    "category": "Edible",
    "topEffect": null
  },
  {
    "name": "EdiPure Peanut Butter Bites",
    "category": "Edible",
    "topEffect": null
  },
  {
    "name": "Egyptian Musk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Egyptian Royalty #1",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Einstein’s Pipe",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "El Chapo",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "El Chapo OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "El Fuego",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "El Jefe",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "El Niño",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "El Perro",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "El-Na",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Elderberry Kush",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Electric Black Mamba",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Electric Kool Aid",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Electric Lemon G",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Electric Lemonade",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Elektra",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Elephant",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Elevated OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Elmer's Glue",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Elphinstone",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Elvis",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Emerald Jack",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Emerald OG",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Emperor Cookie Dough",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Endless Sky",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Enemy of the State",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Enigma",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Eran Almog",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "ErdPurt",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Erez",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Ether",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Ethiopian",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Ethos Apex",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ethos Hash Plant Bx1",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Euforia",
    "category": "Sativa",
    "topEffect": "Euphoric"
  },
  {
    "name": "Eugene Cream",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Euphoria Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Everlast",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Exodus Cheese",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Exodus Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Extreme Cream",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Extreme Impact Auto",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Extreme OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "F 13",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "F 13 Throwback",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "F'n louZER",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "F-Cut OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "FPOG",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Face Off Bx2",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Face Off OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Face Off OG Bx1",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Face on Fire",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Faded Glory",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Fall ‘97",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fallen Angel",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "False Teeth",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Fast Caramelic",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fast Eddy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fast and Vast",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fat Axl",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fat Nelson",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fat Purple",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Fauxsido",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Faygo Red Pop",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Fighting Buddha",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Fire Alien Kush",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Fire Alien Master",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fire Alien Romulan",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fire Alien Strawberry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fire Alien Urkle",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fire Haze",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Fire OG",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Firewalker OG",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "First 48",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "First Light",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Flaming Cookies",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Flavour Pack",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Flight 813",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Flo",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Flo Limone",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Flo OG",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Flo Walker",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Florida Gold",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Florida Lemons",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Florida OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Flowerbomb Kush",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Flowers For Algernon",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fluidic Space",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Flying Hammer",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Focaccia",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Forbidden Fruit",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Forbidden Zkittlez",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Force OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Formula One",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fortune Cookies",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Forum Cut Cookies",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Foul Mouth",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Four Cups",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Four Star General",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Four Way",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Frank's Gift",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Frankenstein",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Fred Flipn’ Stoned",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Freeze Cheese '89",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Freezeland",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "French Bread",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Frida",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Frisian Dew",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Frisian Duck",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Frostbite",
    "category": "Sativa",
    "topEffect": "Happy"
  },
  {
    "name": "Frosted Cherry Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Frosted Freak",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Frosty",
    "category": "Indica",
    "topEffect": "Happy"
  },
  {
    "name": "Frosty Jesus",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Frozen Tangerines",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fruit Ambrosia",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fruit Crusher",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fruit Loop OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fruit Loops",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Fruit Pie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fruit Punch",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Fruit Rollupz",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fruit Spirit",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Fruity Chronic Juice",
    "category": "Indica",
    "topEffect": "Talkative"
  },
  {
    "name": "Fruity Juice",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fruity Widow",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fruitylicious",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Fucking Incredible",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Full Moon",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Fully Loaded",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Funfetti",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Funky Monkey",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Future",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Future #1",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Fuzzy Navel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "G-Cut",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "G-Force",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "G.1000",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "G.O.A.T.",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "G13",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "G13 Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "G13 Haze",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "G13 Skunk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "G13 Widow",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "GDP Electric",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "GI001",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "GMO Cookies",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "GMO Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "GMO Zkittlez",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "GRiZ Kush",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "GSC",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "GTO",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gabriel Sherbet",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Galactic Jack",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Galactica OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Game Changer",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Gammaberry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gandalf OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Ganesh Berry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Garlic Bud",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Gary Payton",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gas Mask",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Gasoline Alley",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gaswerx",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gatekeeper OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gelato",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Gelato #33",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Gelato #41",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gelato Dream",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gelato Pebbles",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gelato Sorbet",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gelatti",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gello Gelato",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gelonade",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gemstone",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Georgia Pine",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ghetto Bird",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ghost Bubba",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Ghost Cookies",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Ghost OG",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Ghost OG Moonshine",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Ghost Pebbles 95",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ghost Rider OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Ghost Ship",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Ghost Tange Haze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ghost Train Haze",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Ghost of Lee Roy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ghostbreath",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Giesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Giesel Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gigabud",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Gilz Nilz",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ginger Ale",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ginger Punch",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Glad Max",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Glass Apple",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Glass Slipper",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Glazed Cherries",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Glue Tech",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "GlueChee",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gnome Walker",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Go Time",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Goat Head",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gobbilygoo",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Gobbstopper",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "God Bud",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "God's Bubba",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "God's Gift",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "God's Green Crack",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "God's Grove",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "God's Treat",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Godberry",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Godfather OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Godfather Purple Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Godzilla",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Godzilla Blood",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Godzilla Glue",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Gog & Magog",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Goji Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Goji OG",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Gold King's Thai",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Gold Star",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Goldberry",
    "category": "Indica",
    "topEffect": "Creative"
  },
  {
    "name": "Golden Calyx",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Golden Gage",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Golden Goat",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Golden Healing",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Golden Lemon",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Golden Nugget",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Golden Panda",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Golden Pineapple",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Golden Soda",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Golden State Banana",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Golden Tangie",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Golden Ticket",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Golden Tiger",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Golden XTRX CO2 Dabbables",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Golden XTRX CO2 Dabbables",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Golden XTRX CO2 Dabbables",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Goldwing",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Goo",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Gooberry",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Good Day",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Good Medicine",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Gorilla Biscuit",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Gorilla Blue",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gorilla Breath",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gorilla Cookies",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Gorilla Girl",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gorilla Grapes",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Gorilla Grips",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Gorilla Snacks",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gorkle",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Government Mule",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Gran Champagne",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grand Doggy Purps",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Grand Hindu",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Grand Hustle",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Granddaddy Purple",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Granddaddy Wonder",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grandma Anderson’s Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grandma’s Batch",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grandma’s Sugar Cookies",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Grandpa Larry OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Grandpa’s Breath",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Grandpa’s Stash",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Granola Funk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grape Ape",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Grape Bubba",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grape Cake",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grape Calyx",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grape Candy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grape Cookies",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Grape Crush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grape Dawg",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grape Diamonds",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grape Drink",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Grape God",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Grape God Bud",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grape Inferno",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Grape Jelly",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Grape Krush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Grape Krush Throwback",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grape Kush",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Grape OX",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Grape Pie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grape Puff",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grape Skunk",
    "category": "Indica",
    "topEffect": "Happy"
  },
  {
    "name": "Grape Smuggler",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grape Soda",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Grape Stomper",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Grape Stomper OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grape Valley Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Grape Vine",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grapefruit",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Grapefruit Diesel",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Grapefruit Haze",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Grapefruit Krush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grapefruit Kush",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Grateful Breath",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grateful Grape",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gravity",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Grease Monkey",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Great White Shark",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Green Avenger",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Green Candy",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Green Cheese",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Green Crack",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Green Crack CBD",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Green Crack Extreme",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Green Door Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Green Dragon",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Green Dream",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Green Goblin",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Green Goddess",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Green Haze",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Green Hornet",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Green Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Green Lantern",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Green Line OG",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Green Love Potion",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Green Magic",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Green Mango",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Green Monster",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Green Ninja",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Green Poison",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Green Python",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Green Queen",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Green Ribbon",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Gremlin",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grilled Cheese",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Grimace",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Grimace OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Grimmdica",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Guard Dawg",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Guava",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Guava Cake",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Guava Chem",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Guava Dawg",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Guava Dub Star",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Guava Gelato",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Guava Kush",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Gucci OG",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Guido Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Gumbo",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Gummo",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Gummy Bears",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Gunslinger",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gupta Haze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gupta Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Guptilla",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Gushers",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Gutbuster",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Gypsy Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Hades Haze",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Hades OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Haleigh’s Hope",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Hammerhead",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Hammershark",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Han Solo Burger",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Hannibal Nectar",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Haole",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Haoma",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Haoma Mist",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Happy Rancher",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Harambe",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Hardcore OG",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Harle-Tsu",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Harlem",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Harlequin",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Harlequin GDP",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Harlequin Joe",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Harley Storm",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Harley Twin",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Harmonia",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Harmony",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Harry Potter",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Hash Plant",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Hashbar OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Hashberry",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Hashplant Haze",
    "category": "Sativa",
    "topEffect": "Happy"
  },
  {
    "name": "Havarra Wedding",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Hawaiian",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Hawaiian Cookies",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Hawaiian Delight",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Hawaiian Diesel",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Hawaiian Dream",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Hawaiian Duckfoot",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Hawaiian Fire",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Hawaiian Haze",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Hawaiian Mayan Gold",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Hawaiian Punch",
    "category": "Sativa",
    "topEffect": "Tingly"
  },
  {
    "name": "Hawaiian Purple Kush",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Hawaiian Sativa",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Hawaiian Skunk",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Hawaiian Snow",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Hawaiian Sunrise",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Hawaiian Thunder Fuck",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Hawaiian Trinity",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Hawai’i ‘78",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Hayley's Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Haze",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Haze Berry",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Haze Heaven",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Haze Mist",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Haze Queen",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Haze Wreck",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Hazmat OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Head Cheese",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Head Trip",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Headband",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Headband Cookies Bx1",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Headbanger",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Heatwave",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Heaven Scent",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Heavenly OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Heavy Bud",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Heavy Duty Fruity",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Heisenberg Kush",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Hell Raiser OG",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Hell's OG",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Hellfire OG",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Hemlock",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Hempstar",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Hercules",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Herijuana",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Hi-Octane",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Hibiscus Sunrise",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "High Five",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "High Noon Irish Cream",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "High School Sweetheart",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Higher Power",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Highwayman",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Himalayan Blackberry",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Himalayan Gold",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Hindu Cream",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Hindu Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Hindu Skunk",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Hindu Sour",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Hippie Chicken",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Hippie Crippler",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Hoarfrost",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Hobbit",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Hog's Breath",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Holland's Hope",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Hollyweed",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Hollywood OG",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Hollywood Pure Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Holy Ghost",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Holy Grail Kush",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Holy Punch",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Holy Roller",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Honduras",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Honey Bananas",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Honey Boo Boo",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Honey Lemon Cheese",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Honey Rock",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Hong Kong",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Hoodwreck",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Horace",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Huckleberries",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Huckleberry",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Huckleberry Cough",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Huckleberry DesStar",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Huckleberry Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Huckleberry Hound",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Huckleberry Soda",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Hulkamania",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Humboldt",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Humboldt Dream",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Humboldt Hawaiian",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Humboldt Headband",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Humboldt Sour Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Humdinger OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Hurkle",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Hurricane",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Hustler Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "I-95",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "ICED Grapefruit",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "IFC OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "IG Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ice",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Ice Cream",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Ice Cream Cake",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Ice Cream Man",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Ice Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ice Princess",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ice Queen",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Ice Wreck",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Iceberg",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Iced Widow",
    "category": "Indica",
    "topEffect": "Happy"
  },
  {
    "name": "Ill OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Illuminati OG",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "In The Pines",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Incredible Bulk",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Incredible Hulk",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Industrial Plant",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Inferno Haze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ingrid",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Intergalactic",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Inzane In The Membrane",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Irene OG",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Irie OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Irish Cream",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Iron Triangle",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Island Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Island Maui Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Island Poison",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Island Sweet Skunk",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Ivan",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "J's Famous Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "J-27",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "J1",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "JGR",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "JT15",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Jabba's Stash",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jack 47",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Jack Burton",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Jack Diesel",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Jack Flash",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Jack Frost",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Jack Haze",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Jack Herer",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Jack Kush",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Jack Plant",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Jack Skellington",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Jack Smack",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Jack Widow",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Jack Wreck",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Jack of Spades",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jack the Ripper",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Jack's Cleaner",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Jack's Dream",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jackalope",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Jacked-Up",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Jackpot",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jacky Girl",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jacky White",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Jack’s Dragon Girl #7",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jack’s Girl",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jah Goo",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Jah Kush",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Jahwaiian",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Jamaican",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Jamaican Dream",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Jamaican Lion",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Jamaican Pearl",
    "category": "Sativa",
    "topEffect": "Euphoric"
  },
  {
    "name": "Jamba Juice",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jane Doe",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jasmine",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jawa Pie",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Jazz",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Jean Guy",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Jedi Kush",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Jelly Breath",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jelly Roll",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Jenni",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Jenny Kush",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Jericho Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Jerusalem Express",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jesse's Girl",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Jesus",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Jesus OG",
    "category": "Indica",
    "topEffect": "Focused"
  },
  {
    "name": "Jet Fuel",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Jigsaw",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jilly Dawg",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jillybean",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Jim OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jimi Hendrix",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jock Horror",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Joe's Dank",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Joe’s Lemonade",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Johnny’s Tonic",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Jorge’s Diamond",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Joseph OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Josh D OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Journeymen",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Juicy Fruit",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Juicy Jack",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Juliet",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Julius Caesar",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Jungle Cake",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jungle Juice",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jungle Scout Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jungle Spice",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Jupiter OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Jurassic Purp",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "K-Train",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "K1",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "K2",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "KC 33",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "KC 36",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "KO Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "KT Dawg",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kaboom",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Kahavvai Mode",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kahuna",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Kaia Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kailua Pua",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kalalau Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kalashnikova",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Kaleidos Dope",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kaleidoscope",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kali 47",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Kali China",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Kali Dog",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kali Haze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kali Mist",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Kandahar",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Kandy Kush",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Kaptn’s Grand Dream",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Karibbean Mango",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Karma Bitch",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Karma OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Karmarado OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Kashmir Kush",
    "category": "Indica",
    "topEffect": "Focused"
  },
  {
    "name": "Katsu Bubba Kush",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Katsu Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Kaua’i Electric",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Kelly Hill Gold",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Ken's Kush",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Kerala",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Kerala Krush",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Kerosene",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Ketama",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Key Lime Pie",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Keystone Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Khalifa Kush",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Khola",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Khufu",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Khyber Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kid N' Kookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kilimanjaro",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Kill Bill",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Killer Grape",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Killer Queen",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Killing Fields",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Kimbo Kush",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "King Cake",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "King Kong",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "King Louis XIII",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "King Thunder Fuck",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "King's Bread",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "King's Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Kings Banner",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kiss",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kiwiskunk",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Kobain Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Koloa Sunrise",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Koloa Sunrise",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Kona Gold",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Kong",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Kool-Aid Smile",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Koolato",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kosher Choco Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kosher Dawg",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kosher Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Kosher Sorbet",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kosher Tangie",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Kosher Tangie Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Krakatoa",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kraken",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Kreamy Karamel",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Krishna Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Kritikal-K",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Kryptonite",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Kuato",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kubbie Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Kuchi",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kurple Fantasy",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Kush Ben Yamini",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kush Cleaner",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kush Hemp",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kush Rise",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kush-N-Cheese",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kushadelic",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Kushage",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Kushashima",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Kushberry",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "L'Eagle Eagle",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "L.A. Cheese",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "L.A. Sorbet",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "L.A. Sunshine",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "L.A.K. Federal Reserve",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "LA Cake",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "LA Chocolat",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "LA Confidential",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "LA Jack",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "LA Kookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "LA Kush",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "LA OG",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "LA Ultra",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "LA Woman",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "LAPD",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "LGBT",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "LSD",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "LVPK",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "La Blanca",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "La Blanca Gold",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "La Niña",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "La Reina de Africa",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Lady Liberty",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ladyburn 1974",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lake of Fire",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Lamb's Bread",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Lambo OG",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Lamborghini",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lambs in Space",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lando's Stash",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Larry Bird Kush",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Larry Cake",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Larry OG",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Las Vegas Purple Kush BX",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Lashkar Gah",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Laughing Buddha",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Laughing Gas",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lavender",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Lavender Haze",
    "category": "Sativa",
    "topEffect": "Euphoric"
  },
  {
    "name": "Lavender Jones",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Lazy Lightning",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lazy Susan CBD",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lazy Train",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Le Silver Royale",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Leda Uno",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Lee Roy",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Legalized OG",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Legend OG",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Legend of Nigeria",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Legendary Lemon",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Legends Gold",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Leia Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Leia OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lem Chem",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Alien Dawg",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Lemon Banana Sherbet",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Bananas",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Berry Candy OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Bubble",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Lemon Cake",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Lemon Cheesecake",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Crumb",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Créme",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Lemon Daddy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Diesel",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Lemon Drop",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Lemon Fire",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Fruit Bound",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon G",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Lemon Garlic OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Haze",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Lemon Ice",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Lemon Jack",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Lemon Jeffery",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Kush",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Lemon Kush Headband",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Larry Lavender",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Marmalade",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Meringue",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Lemon OG Haze",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Lemon OG Kush",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Lemon OZ",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Oasis",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Pebblez",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Pie",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Lemon Prevention",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Puff",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Sativa",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Lemon Skunk",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Lemon Sorbet #3",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Stash CBD",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Stomper",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Tangie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Thai",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Lemon Thai Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemon Tree",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Lemon Walker OG",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Lemon Wreck",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Lemon Zest",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Lemonberry",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Lemonchello 28",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemonder",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Lemongrass",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lemonhead OG",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Lennon",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Leonidas",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Lethal Purple",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Liberty Haze",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Lifesaver",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Lifestar",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lifter",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Light of Jah",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Lil Sebastian",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lilac Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lilac Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lilac OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lime Green Skunk",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Lime Haze",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Lime OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lime Purple Mist",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Lime Skunk",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Lime Sorbet",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Lime Tart",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Limon",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Lions Gate",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Lion’s Milk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Liquid Butter",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Little Devil",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Little Dragon",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Llanera",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Locktite",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Locomotion",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Lodi Dodi",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Logic Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "London Poundcake",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Longbottom Leaf",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Loopy Fruit",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lost Coast Ghost",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lost Coast Hash Plant",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lost Coast OG",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Lost Creek",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lost Sierra Night Nurse",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lotus Larry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Loud Dream",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Loud Lemonade",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Loud Scout",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Love Boat",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Love Is Love",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Love Potion #1",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Love Potion #9",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Love Triangle",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lovelace",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lowryder",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Loyalty",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Luca Brasi",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Luca Brasi x Sour Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Lucid Bolt",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Lucid Dream",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Lucifer OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Lucky Charms",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Lucy",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "M-39",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "M1-56",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "MAC",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "MC1",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "MILF",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "MK Ultra",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Mad Dawg",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Mad Scientist",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Madagascar",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Madcow",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Madhatter",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Madman OG",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Madzilla",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Mag 91",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mag Landrace",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Magellan",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Magic Beans OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Magic Bud",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Magic Jordan",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Magic Melon",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Magnificent Mile",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Magnum",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Magnum Opus",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Magnum PI",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Mai Tai Cookies",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Majestic 12",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mako Haze",
    "category": "Sativa",
    "topEffect": "Euphoric"
  },
  {
    "name": "Malakoff",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Malawi",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Malawi Gold",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Mambo MG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mammoth",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Mandala #1",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mandarin Cookies",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Mandarin Dreams",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Mandarin Jack",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mandarin Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mandarin Sunset",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Mandarin TK",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mandarin Zkittlez",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mandarine 47",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mango",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Mango Dream",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Mango Habanero",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mango Haze",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Mango Kush",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Mango Puff",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mango Sapphire",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mango Sherbert",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mango Tango",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Mangolicious",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Manitoba Poison",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Maple Leaf Indica",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Maramota #10",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Marcosus Marshmellow",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Margaret Cho-G",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Marionberry Kush",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Marionberry Pie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Marley's Collie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Marmalade",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Mars OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Martian Candy",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Martian Mean Green",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Martian Muffins",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Master Bubba",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Master Jedi",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Master Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Master OG",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Master Skunk",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Master Yoda",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Mastodon Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Matanuska Thunder Fuck",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Mataro Blue",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Matsu",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Mau-Mau",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Maui",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Maui Berry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Maui Bubble Gift",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Maui Citrus Punch",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Maui Haole",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Maui Mango Diesel",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Maui Pineapple Chunk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Maui Wowie",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Mauna Kea White Fire OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mazar I Sharif",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Mazar Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Mazar x Blueberry",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Mazar x Blueberry OG",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Mazari",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Mean Misty",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "MediHaze",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Medibud",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Medical 49",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Medicine Man",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Medicine Woman",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Medikit",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Medusa",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Mega Jackpot",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Megalodon",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Mekamika Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Melon Gum",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Melonade",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Melonberry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Member Berry",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Member OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Memory Loss",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Mendo Afgoo",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Mendo Breath",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Mendo Montage",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mendo Queen",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mendo Supremo",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mendocino Madness",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mendocino Purps",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Mendocino Skunk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mendodawg",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mercury OG",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Merlot OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Mexican",
    "category": "Sativa",
    "topEffect": "Hungry"
  },
  {
    "name": "Mexican Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mexican Sativa",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Mi-Lano",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Michael Phelps OG",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Michka",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Mickey Kush",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Middlefork",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Middlefork x Pineapple Express",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Midnight",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Midnight Express",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Midnight Mass",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mighty Glue",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mighty Quin",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mike Larry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Milky Way",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Millennium",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mimosa",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Mindscape",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mint Chocolate Chip",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Mint Lemonade",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Miss Columbian",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Miss Fortune Cookie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Miss U.S.A.",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mission Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Misty Kush",
    "category": "Indica",
    "topEffect": "Happy"
  },
  {
    "name": "Misty Morning",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mob Boss",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Moby Dick",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Moby Dick 2.0",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mochi",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Moloka’i Frost",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Moloka’i Purpz",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Money Maker",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Monkey Bread #1",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Monkey Paw",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Monkey Thunder",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Monolith",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Monster Cookies",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Monster OG",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Monster Profit",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Montana Silvertip",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Moon Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Moon Drops",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Moon Walk",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Moonbeam",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Moonbow",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Moondance",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Moonshine Haze",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Moontang",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Moonwalker Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Moose and Lobsta",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "More Cowbell",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Morning Flight",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Morning Glory",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Morning Star",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Morockin’ Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Morpheus",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Mossad",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Mossimo OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Motavation",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Mother Tongue",
    "category": "Sativa",
    "topEffect": "Euphoric"
  },
  {
    "name": "Mother of All Cherries",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Mother of Berries",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Mother's Milk",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Mothertongue",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Mother’s Finest",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Mother’s Helper",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Motorbreath",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Motown Lockdown",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mountain Girl",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mountain Girl x Grape Ape",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mountain Temple",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Mountain Thunder",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Mozambique Poison",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mr. Nice",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Mr. Tusk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ms. Universe",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mt. Cook",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Mt. Hood Magic",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Mt. Rainier",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mud Bite",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Murkle",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Mystery 98",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Mystery Jazz",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "NL5 Haze Mist",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "NY Cheese",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "NY-47",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "NYC Diesel",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "NYPD",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Nana’s Fix",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Napalm OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Narnia",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Nchoosha Y",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Nebula",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Nebula II CBD",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Nectarine Lips",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Negra 44",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Neil Haze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Nepalese",
    "category": "Sativa",
    "topEffect": "Happy"
  },
  {
    "name": "Nepalese Jam",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Neptune Kush",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Neptune OG",
    "category": "Indica",
    "topEffect": "Focused"
  },
  {
    "name": "Neroli 91",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Nevada Privada",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Nevil's Wreck",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Neville's Haze",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "New Glue",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Newberry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Nexus OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Nice Cherry",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Nicole Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Night Nurse",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Night Terror OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Night Train",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "NightFire OG",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Nightmare Cookies",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Nightmare OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Nina Limone",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Ninja Fruit",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Nor Cal Purps",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Nordle",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "North American Indica",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "North American Sativa",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "North Indian",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Northern Berry",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Northern Cross",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Northern Hashplant",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Northern Lights",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Northern Lights #5",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Northern Lights #5 x Haze",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Northern Skunk",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Northern Wreck",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Northwest Pineapple",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Nova",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Nuclear Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Nuggetry OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "NukeHeads",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Nuken",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Nurse Jackie",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "OB Ripper",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "OCA Gold",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "OCA’s Cloud 9",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "OCD",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "OG #18",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "OG 1 Kenobi",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "OG Cheese",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "OG Chem",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "OG Critical",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "OG Diesel Kush",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "OG Eddy Lepp",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "OG Glue Sniffer",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "OG Kush",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "OG LA Affie",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "OG Lime Killer",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "OG Limekiller",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "OG Los Angeles Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "OG Poison",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "OG Purple Fire Thai",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "OG Ringo",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "OG Shark",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "OG Skunk",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "OG Sour Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "OG Strawberry",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "OG Strawberry Star Killer",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "OG Tonic",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "OG Wreck",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "OG's Pearl",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "OGDLUX",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "OGKB",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "OGKZ",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "OGiesel",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "OZ Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Obama Kush",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Ocean Grown Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ocean View",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Odyssey",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Ogre",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Ogre Berry",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Ol' Betsy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Old Dirty Biker",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Old Lyme Connecticut OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Old Mother Sativa",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Old School OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Old Toby",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Oldtimer’s Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Omega",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Omega Dawg",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "One to One",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Opal OG Kush",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Opium",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Or",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Orange Afghani",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Orange Blossom",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Orange Bud",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Orange Cookies",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Orange Cream",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Orange Creamsicle",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Orange Crush",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Orange Diesel",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Orange Dream",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Orange Durban",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Orange Fanta",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Orange Fruit Bound",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Orange Harambe",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Orange Haze",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Orange Hill Special",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Orange Juice",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Orange Kush",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Orange Kush Breath",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Orange Kush Cake",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Orange Poison",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Orange Romulan",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Orange Sherbert",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Orange Skunk",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Orange Snow Cone",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Orange Turbo",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Orange Velvet",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Orange Velvet Underground",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Orange Wreck",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Orangutang",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Oregon Bus Pass",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Oregon Diesel",
    "category": "Indica",
    "topEffect": "Happy"
  },
  {
    "name": "Oregon Lemons",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Oregon Pineapple",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Oregon Pinot Noir",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Organic Diesel",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Orient Express",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Original Glue",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Original Mandarin Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ortega",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Oteil’s Egyptian Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Outer Space",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Outlaw",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Ozma",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "P-51",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "P-91",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "PB Soufflé",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "PTSD",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "PVC OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Pablo’s Mint",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pacific Blue",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Pacific Frost",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pagoda",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Pakistan Valley Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Pakistani Chitral Kush",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Palm Tree CBD",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Pamelina",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Pan Jam",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Panama Punch",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Panama Red",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Panda OG",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Pandora's Box",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Panzer Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Papa's OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Papaya",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Paradise Waits",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Paris OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Paris XXX",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Patti Cake",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Peach Cobbler",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Peach Crescendo F-1",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Peach Puree",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Peaches and Cream",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Peachy Mack",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Peanut Butter Breath",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pearl Scout Cookies",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Pebble Pie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pele's Fire OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pennywise",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Pepe Le Chem",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pepe Le Dank",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Peppermint Cookies",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Perfect Purple",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Permafrost",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Pestilence",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Petro Chem",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Petrolia Headstash",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Peyote Cookies",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Peyton Manning",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pez",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Phantom Arrow",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Phantom Cookies",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Phantom OG",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Phatt Frutty",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Pheno 51",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Phishhead Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Pie 95",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pie Face OG",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Pie Hoe",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Pie Til I Die",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pie Tree",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pie of the Tiger",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pine Cone",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pine Queen Dream",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pine Tar Kush",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Pineapple",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Pineapple Calyx",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pineapple Chunk",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Pineapple Cookies",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Pineapple Diesel",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Pineapple Dog Shit",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pineapple Express",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Pineapple Fields",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Pineapple Hash Plant",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pineapple Haze",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Pineapple Jack",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Pineapple Kush",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Pineapple Mayhem",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pineapple OG",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Pineapple Punch",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Pineapple Purple Skunk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pineapple Purps",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Pineapple SAGE",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pineapple Sage",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Pineapple Skunk",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Pineapple Super Silver Haze",
    "category": "Sativa",
    "topEffect": "Happy"
  },
  {
    "name": "Pineapple Thai",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Pineapple Trainwreck",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Pineapple Upside Down Cake",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Pineapple Zest",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pineberry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pinewarp",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pink Berry",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Pink Bubba",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Pink Champagne",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Pink Cookies",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Pink Death Star",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Pink Hawaiian",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pink Kush",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Pink Lemonade",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Pink Mango",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Pink Panther",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Pink Panties",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Pink Pez",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pink Starburst",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Pink Sunset",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Pinkman Goo",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Pinot Green",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Pirate Radio",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pitbull",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Piña Collision",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Placenta",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Platinum Bubba Kush",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Platinum Calyx",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Platinum GSC",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Platinum Huckleberry Cookies",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Platinum Kush",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Platinum OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Platinum Purple Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Platinum Sour Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Platinum Wreck",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Plum Dawg Millionaire",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Plumberry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Plushberry",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Pluto Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Poison Fruit",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Poison Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Pokie",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Poochie Love",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Pop Rox",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Popcorn Kush",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Pot of Gold",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Powderhound",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Power Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Power Plant",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Power Purps",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Powernap",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Prayer Tower",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pre-98 Bubba Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Predator Pink",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Presidential OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Prevention",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Primus",
    "category": "Indica",
    "topEffect": "Happy"
  },
  {
    "name": "Princess",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Princess’s Tiara",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Prismatic Jack",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Professor Chaos",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Project Blue Book",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Proper BHO Shatter",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Proper BHO Shatter",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Proper BHO Shatter",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Proper PHO Shatter",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Proper PHO Shatter",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Proper PHO Shatter",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Puck Yeah",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Pulsar",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Puna Buddaz",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Puna Budder",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Punky Lion",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Punto Rojo (Tierra Adentro)",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Punxsy Punch",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pura Vida",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Pure Afghan",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Pure Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Pure Love",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Pure OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Pure Power Plant",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Purple AK-47",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Purple Afghan Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Purple Afghani",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Purple Alien OG",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Purple Animal Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Arrow",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Purple Aurora",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Berry",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Purple Berry Skunk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Bubba",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Purple Bud",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Purple Buddha",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Purple Bush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Purple Candy",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Purple Champagne",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Purple Cheddar",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Purple Cheese",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Purple Chemdawg",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Purple Cotton Candy",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Purple Cow",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Purple Crack",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Purple Cream",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Purple Diesel",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Purple Dog Shit",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Purple Domina",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Dragon",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Purple Dream",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Purple Elephant",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Purple Frost",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Glue",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Goat",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Goo",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Purple Gorilla",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Purple Happy Rancher",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Purple Hashplant",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Purple Haze",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Purple Headband",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Purple Hindu Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Purple Ice",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Purple Jack",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Purple Killer",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Purple Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Purple Linda",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Purple Majik",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Martian Kush",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Purple Maui",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Moby Dick",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Monkey Balls",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Purple Moss",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Mr. Nice",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Purple Nepal",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Purple OG Kush",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Purple Pantera",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Panty Dropper",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Purple Paralysis",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Purple Passion",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Purple People Eater",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Purple Pie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Pinecone",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Purple Power",
    "category": "Sativa",
    "topEffect": "Tingly"
  },
  {
    "name": "Purple Prevention",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Princess",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Purple Punch",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Purple Raine",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Purple Reign",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Rhino",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Purple Roze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Sage ",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Skunk",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Purple Snowman",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Sour Diesel",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Purple Star",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Purple Sunset",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Purple Swish",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Purple Tangie",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Purple Tears",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Thai",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Purple Tide",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Tonic",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Purple Trainwreck",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Purple Unicorn",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Purple Urkle",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Purple Voodoo",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Purple Widow",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Purple Wreck",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Purple Zkittlez",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Purps OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Q3",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Qleaner",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Qrazy Train",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Quad Dawg",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Quantum Kush",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Quasar",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Quattro Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Quebec Gold",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Queen Mother Goji",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Queen of Hearts",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Queen's Panties",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Querkle",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Quin-N-Tonic",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Quiver Killer Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Qush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "R-4",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "R.K.S.",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Race Fuel OG",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Rafael",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Rainbow",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Rainbow Chip",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Rainbow Jimmies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Rainbow Jones",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Rainbow Mints",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Raindance",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Rainmaker",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ramses",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Rare Dankness #1",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Rare Darkness",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Rare Hindu",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Raskal OG",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Raspberry Cough",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Raspberry Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Raspberry Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Raspberry Tart",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Raw Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Rawtton",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ray Charles",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Rebel Berry OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Rebel God Smoke",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Rebel Tangie Kandy",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Reclining Buddha",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Recon",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Rectangle",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Red Cherry Berry",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Red Congolese",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Red Diesel",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Red Dragon",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Red Dwarf",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Red Eye OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Red Haze",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Red Headed Stranger",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Red Kross",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Red Poison",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Red Rhino",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Red Velvet Pie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Red Widow",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Redd Cross",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Redding OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Redwood Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Remedy",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Remo Chemo",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Rene",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Rene Mist",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Renegade Rx CBD",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Revival",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Richie Rich",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Riddler OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ridge Berry",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Rigger Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Riley Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Ringo's Gift",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Rip City Purps",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Ripped Bubba",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Rise ‘n’ Shine",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "River Song",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Road Dawg",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Rob Ford Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Robert Plant",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Rockbud",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Rocket Fuel",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Rocklock",
    "category": "Indica",
    "topEffect": "Creative"
  },
  {
    "name": "Rockstar",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Rockstar Kush",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Rockstar Master Kush",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Rocky Dennis",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Rocky Mountain Blueberry",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Rocky Mountain High",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Rollex OG Kush",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Rolls Choice",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Romping Goddess",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Romulan",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Romulan Grapefruit",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Romulan Haze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Root Beer Kush",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Rosaberry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Rose Bud",
    "category": "Indica",
    "topEffect": "Creative"
  },
  {
    "name": "Royal Chemdawg",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Royal Dwarf",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Royal Flush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Royal Haze",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Royal Highness",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Royal Kush",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Royal Purple Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Royal Salute",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Royal Tree Sherbet",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Rozé",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Rubicon",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Ruby Rose",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "RudeBoi OG",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Rug Burn OG",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Runtz",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Russian Assassin",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Russian Doll",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Russian Rocket Fuel",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Russian Roulette",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "SAGE",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "SAGE Walker",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "SFV Dog",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "SFV OG",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "SFV OG Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "SPK",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Sacrificial Lamb",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Safety Meeting",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sage N Sour",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Salmon River OG",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Samoa Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Santa Maria",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Santa Sativa",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Sapphire Cherries",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sapphire OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sapphire Scout",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sapphire Star",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sasquatch Sap",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Satellite OG",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Satori",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Satsuma",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Saturn OG",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Savage Citrus Sunshine",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Savant's Grail",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sch'Lemon Cake",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Schrom",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Scooby Snacks",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Scott's OG",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Scout's Honor",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Scroopy Noopers",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Seattle Blue",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Seattle Cough",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Seattle Summer",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "SeattleSoda",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Secret Garden OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Secret Recipe",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Sensi Skunk",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Sensi Star",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Sequoia Strawberry",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Sergerbloom Haze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Serious 6",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Serious Happiness",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Serious Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sexxpot",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Señor Jack",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Shadow Dancer",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Shaman",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Shaman’s Dream",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Shangri-La",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Shark Attack",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Shark Bite",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Shark Shock",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Shark Widow",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sharksbreath",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Sherbert",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Sherblato",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Shiatsu Kush",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Shining Silver Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Shipwreck",
    "category": "Sativa",
    "topEffect": "Happy"
  },
  {
    "name": "Shishkaberry",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Shiskaquine",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Shit",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Shiva Skunk",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Shoreline",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Short and Sweet",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Shurman",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Siddhartha’s Dream",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sidetracked",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sierra Mist",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Silver Back",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Silver Bubble",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Silver Calyx",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Silver Cheese",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Silver Cindy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Silver Haze",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Silver Kush",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Silver L.A.",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Silver Mountain",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Silver Nina",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Silver Pearl",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Silver Surfer",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Silver Train",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Silverback Gorilla",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Silverfalls Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Silverhawks OG",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Sin City Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Sin Valley OG",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "SinMint Cookies",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Sinai",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Sirius Black",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Sister Glue",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Six Shooter",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sizzurp",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Skins Skunk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Skunk 47",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Skunk Ape",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Skunk Dawg",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Skunk Haze",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Skunk Hero",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Skunk No. 1",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Skunk+",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Skunkberry",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Skunky Diesel",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Sky Lotus",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sky Master",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Skydog",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Skywalker Alien",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Slazerbeam",
    "category": "Sativa",
    "topEffect": "Happy"
  },
  {
    "name": "SleeSkunk",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "SleeStack",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Slice of Heaven",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Slimer OG",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Slurpie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Slurricane",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Smarties",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Smelliot",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Smooth Operator",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Snoop Dogg OG",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Snoop's Dream",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Snow Bud",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Snow Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Snow Goddess",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Snow Leopard",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Snow Lotus",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Snow Monster",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Snow Mountain",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Snow Ryder",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Snow White",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "SnowLAnd",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Snowball",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Snowcap",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Snowdawg 2",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Snowman",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sojay Haze",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Solo’s Stash",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Somango",
    "category": "Indica",
    "topEffect": "Focused"
  },
  {
    "name": "Somango Widow",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Somari",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Somaui",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sonic Screwdriver",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Sonoma Coma",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Soraya",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sorbet",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sorbet #11",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sorbet #4",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sorbet Dreams",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sorbet Stash",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sorbetto",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sorcerer’s Apprentice",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Soul Assassin OG",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Soul Shine",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Soulshine Aloha",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Sour Alien",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Sour Amnesia",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Sour Ape",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Sour Apple",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Sour Banana Sherbet",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Sour Blueberry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sour Boggle",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sour Breath",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Sour Bubba",
    "category": "Indica",
    "topEffect": "Happy"
  },
  {
    "name": "Sour Bubble",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Sour Candy",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Sour Cheese",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Sour Cherry Sherbert",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Sour Chocolate",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Sour Chunk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sour Cookies",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Sour Cream",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Sour D*OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sour Diesel",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Sour Dream",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Sour Dubble",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Sour Flower",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Sour Grape",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Sour Haze",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Sour Headband",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Sour Jack",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Sour Jilly",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sour Joker",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Sour Kosher",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sour Kush",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Sour LSD",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Sour Lemon OG",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Sour Lemons",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sour Lifesavers",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sour Maui",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Sour OG",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Sour OG Cheese",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sour Patch Kiss",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Sour Pebbles",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Sour Poison",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Sour Power",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Sour Power OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sour Puss",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sour Sorbet",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sour Space Candy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sour Spyder",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Sour Star Head",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Sour Strawberry",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Sour Strawberry Diesel",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Sour StrawburieD",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sour Sunset",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Sour Tangie",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Sour Tsunami",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Sour Urkle",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Sour Willie",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Sourlope",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "South American",
    "category": "Sativa",
    "topEffect": "Hungry"
  },
  {
    "name": "South Asian Indica",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "South Asian Sativa",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "South Central LA",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "South Indian Indica",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "South Indian Sativa",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Southern Lights",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Space Bomb",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Space Cake",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Space Candy",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Space Cream",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Space Dawg",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Space Jill",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Space Monster",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Space Needle",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Space Poison",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Space Queen",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Special K",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Special Kush #1",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Special Sauce",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Spice",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Spicy Disco",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Spiked Punch",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Spirit of '76",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Spliff’s Strawberry",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Spoetnik #1",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Spumoni",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sputnik",
    "category": "Sativa",
    "topEffect": "Tingly"
  },
  {
    "name": "Spyder Mon",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Star 47",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Star Berry Indica",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Star Cookie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Star Killer",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Star Master Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Star Pupil",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Star Tonic",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "StarBud",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Stardawg",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Stardawg 91",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Stardawg Guava",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Starfighter",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Starlet Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Starman",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Starry Night",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Stashsquatch",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Stella Blue",
    "category": "Sativa",
    "topEffect": "Happy"
  },
  {
    "name": "Stephen Hawking Kush",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Stevie Wonder",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Stinky Pete",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Stone Free",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Stoopid Fruits",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Straight A's Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Strange Brew",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Stratosphere",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Strawberries & Cream",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Strawberry",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Strawberry Akeil",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Strawberry Alien Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Strawberry Amnesia",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Strawberry Banana",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Strawberry Blonde",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Strawberry Blondie",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Strawberry Blue",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Strawberry Cake",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Strawberry Cheesecake",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Strawberry Cough",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Strawberry Diesel",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Strawberry Dream",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Strawberry Durban Diesel",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Strawberry Fields",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Strawberry Frost",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Strawberry Fruit Bound",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Strawberry Gum",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Strawberry Ice",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Strawberry Kush",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Strawberry Lemonade",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Strawberry Mango Haze",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Strawberry Milkshake",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Strawberry OG",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Strawberry Satori",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Strawberry Shortcake",
    "category": "Indica",
    "topEffect": "Creative"
  },
  {
    "name": "Strawberry Snow Cone",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Strawberry Sorbet",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Strawberry Switchblade",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Strawberry Tree",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Stretch",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sublime",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Sugar Black Rose",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Sugar Breath",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sugar Calyx",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sugar Cookie",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Sugar Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Sugar Mama",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Sugar Pine",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sugar Plum",
    "category": "Sativa",
    "topEffect": "Tingly"
  },
  {
    "name": "Sugar Plum Sunset",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Sugar Punch",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Sugar Shack",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Sugartown Express",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Suicide Girl",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Summer Breeze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Summertime Squeeze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Sumo Grande",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Sumo's OG Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Sun Maiden",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sun Ra",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Sunburn",
    "category": "Sativa",
    "topEffect": "Tingly"
  },
  {
    "name": "Sundae Driver",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Sunlight Skunk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sunny D",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sunset",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Sunset Fire",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sunset Haze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sunshine",
    "category": "Sativa",
    "topEffect": "Happy"
  },
  {
    "name": "Sunshine #4",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Sunshine Daydream",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Supa Don",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Super  Chronic",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Super Blue Dream",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Super Bud",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "Super Cat Piss",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Super Cheese",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Super G",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Super Glu",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Super Green Crack",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Super Jack",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Super Kush",
    "category": "Indica",
    "topEffect": "Happy"
  },
  {
    "name": "Super Lemon Haze",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Super Lemon OG",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Super Silver Bullet",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Super Silver Hash Plant",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Super Silver Haze",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Super Silver Lights",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Super Skunk",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Super Snow Dog",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Super Snow Lotus",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Super Sour Diesel",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Super Sour Lemon",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Super Sour OG",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Super Sour Skunk",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Super Sour Widow",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Super Sweet",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Superb OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Supergirl",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Superglue",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Superman OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Supermax OG",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Supernatural",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Supernova",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Superstar",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Suver Haze",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Suzy Q",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Swazi Gold",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Sweet & Sour Cindy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sweet Amnesia Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Sweet Baby Jane",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Sweet Berry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sweet Black Angel",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Sweet Cheese",
    "category": "Sativa",
    "topEffect": "Happy"
  },
  {
    "name": "Sweet Cindy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sweet Deep Grapefruit",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "Sweet Diesel",
    "category": "Sativa",
    "topEffect": "Giggly"
  },
  {
    "name": "Sweet Dream",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sweet Dreams",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Sweet Dreams",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Sweet Harlem Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sweet Hawaiian Tangie Banana",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sweet Jane",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Sweet Jesus",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Sweet Kush",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Sweet Lafayette",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Sweet Nina",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sweet Pebbles",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sweet Pink",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sweet Pure CBD",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sweet Purple",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sweet Skunk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sweet Tooth",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Sweet Valley Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Sweet and Sour Widow",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Sweeties",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Swiss Bliss",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Swiss Gold",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Swiss Indica",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Swiss Sativa",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Swiss Tsunami",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "THC Bomb",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "TJ's CBD",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tachllta Till",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tahoe Alien",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "Tahoe Frostbite",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tahoe Hydro Champagne",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tahoe Hydro OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tahoe OG Kush",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Tahoe Purps",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Taliban Poison",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Tang Eray",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tangelo",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tangelo Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tangenesia",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tangerine",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Tangerine Dream",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Tangerine G13",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tangerine Haze",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Tangerine Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Tangerine Man",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Tangerine Power",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Tangerine Sunrise",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Tangerine Trainwreck Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Tangie",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Tangie Biscotti",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Tangie Cookies",
    "category": "Sativa",
    "topEffect": "Euphoric"
  },
  {
    "name": "Tangie Dream",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tangie Ghost Train",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Tangie Sunrise",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tangier Chilly",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tangilope",
    "category": "Sativa",
    "topEffect": "Happy"
  },
  {
    "name": "Tango Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tardis",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Tarmonster",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tembo Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tenderheart",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Terminator OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Terpwin Station",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tesla",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tesla Tower",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Testarossa",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Thai",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Thai Fantasy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Thai Girl",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "Thai Haze",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Thai Lights",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Thai-Tanic",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Thaidal Wave",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The Big Dirty",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The Black",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "The Bling",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The Blintz",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The Blood",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "The Boss",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The Brotherhood",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The CBG Blend",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The Cough",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "The Doctor",
    "category": "Indica",
    "topEffect": "Giggly"
  },
  {
    "name": "The Flav",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "The Forbidden Candy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The Fork",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "The Fuzz",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The Gift",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The Grunk",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "The Guice",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The Hog",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "The Lime",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The Loops",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "The Mountain",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The OX",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "The One",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "The Ooze",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "The Original Lemonnade",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The Real McCoy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The Sauce",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "The Sheriff",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The Sister",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "The Third Dimension",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "The Truth",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "The Vision",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The Void",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "The White",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "The White Angel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "The Wife",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "The Wills",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Thelonious Skunk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Thin Mint GSC",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Think Different",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Thor's Hammer",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Three Blue Kings",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Throwback Kush",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Thunderbird Rose",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Thunderstruck",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Tickle Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tiger Woods",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tiger's Milk",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Tigermelon",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Tillamook Strawberry",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Timewreck",
    "category": "Sativa",
    "topEffect": "Euphoric"
  },
  {
    "name": "Tina",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Tina Danza",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Titan's Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Tokyo OG",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Tommy's Home Grown",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tonics Web",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Tora Bora",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Total Paralysis",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Toxic",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Toxic Punch",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Training Day",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Trainwreck",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Tranquil Elephantizer: Remix",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Transformer",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Trap Star",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Trash",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Travel Joint",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Treasure Island",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Tree of Life",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tres Dawg",
    "category": "Hybrid",
    "topEffect": "Sleepy"
  },
  {
    "name": "Trewbacca",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Triangle Kush",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Triangle Mints",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Trident",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Trifecta",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Trinity",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Trinity Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Triple Cheese",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Triple Diesel",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Triple Scoop",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tristar Pebbles",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Trix",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Trophy Wife",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tropic Thunder",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tropical Tang",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Tropicali",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Tropicana Cookies",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Tropicana Punch",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Truberry OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "True Face",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "True Love",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "True OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "True X",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Trueberry",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Truffle Butter",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Truffula Tree",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Truth Serum",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tuna Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Tuna OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Turbo",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Turbo Mind Warp",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tutankhamon",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Tutti Frutti",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Twista",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Twisted Citrus",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Two Beards",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Tyson",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "U2 Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "UK Cheese",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "UW",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Ultimate Trainwreck",
    "category": "Sativa",
    "topEffect": "Aroused"
  },
  {
    "name": "Ultra Banana",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Ultra Sonja",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Ultra Sour",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "UltraViolet OG",
    "category": "Indica",
    "topEffect": "Tingly"
  },
  {
    "name": "Urkle Train Haze",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "VCDC",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "VOTS AZ Super Sour OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "VVS Chem",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Vader OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Valentine X",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Valley Ghash",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Valley Girl",
    "category": "Hybrid",
    "topEffect": "Happy"
  },
  {
    "name": "Valley Vixen",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Vanilla Frosting",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Vanilla Gorilla",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Vanilla Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Vanilluna",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Velvet Bud",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Velvet Krush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Velvet Purps",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Velvet Ropes",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Venice OG",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Venom OG",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Venus OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Verde Electric",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Versace",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Very Berry Haze",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Very Cherry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Vietnamese Bubba",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Violator Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Violet Delight",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "Violeta",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Viper",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Vixen",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Voodoo",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Vortex",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "WMD",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "WSU",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "WTF",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Wabanaki",
    "category": "Sativa",
    "topEffect": "Focused"
  },
  {
    "name": "Waipi'o Hapa",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Waist Deep",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Wakanda OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Waldo",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Walker Kush",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Wally OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Walrus Kush",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Walter White",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Wappa",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Warda“reek”n OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Warlock",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Washing Machine",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Watermelon",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Watermelon Zkittlez",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Webster",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Wedding Cake",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Wedding Crasher",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Weebe’s World",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Wellness OG",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "Wembley",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "West Coast Dawg",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "West Coast Willie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "West OG",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Wet Dream",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Where's My Bike",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Whipped Cherries",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Whitaker Blues",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "White 99",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "White Bastard",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "White Berry",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "White Bubblegum",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "White Buffalo",
    "category": "Sativa",
    "topEffect": "Euphoric"
  },
  {
    "name": "White Caramel Cookie",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "White Castle",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Cheese",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "White Cherry Truffle",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Choco",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Choco Haze",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "White Chocolate",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Cookies",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "White Dawg",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "White Dawg Fire OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Diesel",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "White Domina",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "White Dragon",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "White Dream",
    "category": "Hybrid",
    "topEffect": "Uplifted"
  },
  {
    "name": "White Durban",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "White Elephant",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "White Empress",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "White Fire 43",
    "category": "Indica",
    "topEffect": "Hungry"
  },
  {
    "name": "White Fire Alien OG",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "White Fire OG",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "White Funk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Girl",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Gold",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "White Gorilla",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "White Harmony",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Haze",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "White Ice",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Knight",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "White Kryptonite",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "White Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "White LSD",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "White Label Jack Herer",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Label Rhino",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Lavender",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "White Lemon",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Lightning",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "White Lotus",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "White Master",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Moonshine",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "White Nightmare",
    "category": "Sativa",
    "topEffect": "Euphoric"
  },
  {
    "name": "White OG",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "White Queen",
    "category": "Hybrid",
    "topEffect": "Hungry"
  },
  {
    "name": "White Rhino",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "White Romulan",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "White Runtz",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Russian",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "White Ryder",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Sangria",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "White Siberian",
    "category": "Hybrid",
    "topEffect": "Aroused"
  },
  {
    "name": "White Skunk",
    "category": "Hybrid",
    "topEffect": "Euphoric"
  },
  {
    "name": "White Slipper",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "White Smurf",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Strawberry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Strawberry Skunk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Super Skunk",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Tahoe Cookies",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "White Tygh Dream",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "White Urkle",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "White Walker Kush",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "White Walrus",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "White Widow",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "White Zombie",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Whiteout",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Whitewalker OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Whoopie Pie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Wild Thailand",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Willie Berrie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Willie Cheesie",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Willie Nelson",
    "category": "Sativa",
    "topEffect": "Creative"
  },
  {
    "name": "Willie’s Ghost",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Willy G’s Lebanese",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Willy Wonka",
    "category": "Sativa",
    "topEffect": "Talkative"
  },
  {
    "name": "Willy's Wonder",
    "category": "Indica",
    "topEffect": "Euphoric"
  },
  {
    "name": "Wipeout Express",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Wish Mountain",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Wolfberry",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Wonder Haze",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Wonder Kid",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Wonder Woman",
    "category": "Hybrid",
    "topEffect": "Giggly"
  },
  {
    "name": "Wonder Woman OG",
    "category": "Indica",
    "topEffect": "Aroused"
  },
  {
    "name": "Wonka Bars",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Wonka's Bubblicious",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "Woody Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Wookie",
    "category": "Hybrid",
    "topEffect": "Talkative"
  },
  {
    "name": "Wookies",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Wookie’s Cookies",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Wreckage",
    "category": "Hybrid",
    "topEffect": "Energetic"
  },
  {
    "name": "Wyld Stallion",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "X-File",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "X-Files",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "X-Wing",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "X-tra Chz",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "X18 Pure Pakistani",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "XJ-13",
    "category": "Hybrid",
    "topEffect": "Creative"
  },
  {
    "name": "XXX 420",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "XXX OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Xanadu",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Y Griega",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Y-Kiki",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "YEM OG",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Yabba Dabba Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Yeti OG",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Yoda OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Yoda's Brain",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Yogi Diesel",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Yolo Berry",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Yumboldt",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Yummy",
    "category": "Hybrid",
    "topEffect": "Relaxed"
  },
  {
    "name": "Zamaldelica",
    "category": "Sativa",
    "topEffect": null
  },
  {
    "name": "Zardde Gold",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "ZeitGeist",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Zelda",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Zelly’s Gift",
    "category": "Sativa",
    "topEffect": "Uplifted"
  },
  {
    "name": "Zen",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Zerculese",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Zeta Sage",
    "category": "Sativa",
    "topEffect": "Energetic"
  },
  {
    "name": "Zeus OG",
    "category": "Hybrid",
    "topEffect": "Tingly"
  },
  {
    "name": "Zkittlez",
    "category": "Indica",
    "topEffect": "Relaxed"
  },
  {
    "name": "Zombie Kush",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Zombie OG",
    "category": "Indica",
    "topEffect": "Sleepy"
  },
  {
    "name": "Zookies",
    "category": "Hybrid",
    "topEffect": "Focused"
  },
  {
    "name": "Zoom Pie",
    "category": "Indica",
    "topEffect": null
  },
  {
    "name": "Zour Apples",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "Zsweet Insanity",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "hai Fantasy",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "ʻAlenuihāhā",
    "category": "Hybrid",
    "topEffect": null
  },
  {
    "name": "‘88 G13 Hashplant",
    "category": "Hybrid",
    "topEffect": null
  }
]